module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-0 ma-0 rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.bezMitglieder) + " suchen")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-autocomplete', {
    staticClass: "mx-4",
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Suchen...",
      "items": _vm.selectBundesbruder
    },
    on: {
      "change": function($event) {
        return _vm.selectBbr()
      }
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  }), _vm._v(" "), (_vm.bundesbruder) ? _c('div', [_c('dialogKontakt', {
    attrs: {
      "visible": _vm.showBbr,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showBbr = $event
      },
      "close": function($event) {
        _vm.showBbr = false
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dcc3dfb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/bundesbruderSuche.vue
// module id = 762
// module chunks = 15